import React, { useContext, useState } from 'react';
import { Form } from 'react-bootstrap';
import { DimensionWrapper } from 'lb-components';
import { Button, Icon } from 'lb-components';
import {
  UseAlert,
  UseGuest,
  UseRecovery,
  UseSecurityCode,
  UseSignIn,
  UseRegister,
  UseUser,
  UseOTP,
  UsePhoneVerification,
} from 'lb-store/src/hooks';
import { Api, Toast, useTranslation } from 'lb-store';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import {
  RegisterBackground,
  GiftIcon,
  RegisterBonus,
} from '../../assets/icons';

export const AuthContainer = ({ size, classes }) => {
  const { t, i18n } = useTranslation();
  const { keepAlive } = UseUser();
  const recovery = UseRecovery();
  const otp = UseOTP();
  const alert = UseAlert();
  const securityCode = UseSecurityCode();
  const guest = UseGuest();
  const signInModal = UseSignIn();
  const registerModal = UseRegister();
  const phoneVerification = UsePhoneVerification();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  /*შეცდომები*/
  const signIn = () => {
    let params = {
      user: username,
      pass: password,
    };
    guest.SignIn({
      data: params,
      onSuccess: () => {
        keepAlive().then((res) => {
          if (res.data.mobile_verified === 'no') {
            phoneVerification.open({
              onSuccess: () => {
                alert.open({ message: t('თქვენი ნომერი ვერიფიცირებულია') });
              },
            });
          }
        });
      },
      onError: (error) => {
        //console.log(error);
        if (error?.code) {
          switch (error?.code) {
            case 'captcha':
              securityCode.open({
                onSuccess: (code, callback, close) => {
                  if (!code) {
                    callback(t('შეავსეთ ველი'));
                    return;
                  }
                  guest
                    .SignInWithoutCallback({
                      data: {
                        ...params,
                        captcha: code,
                      },
                    })
                    .then((res) => {
                      if (res.status) {
                        close();
                        keepAlive().then((res) => {
                          if (res.data.mobile_verified === 'no') {
                            phoneVerification.open({
                              onSuccess: () => {
                                alert.open({
                                  message: t('თქვენი ნომერი ვერიფიცირებულია'),
                                });
                              },
                            });
                          }
                        });
                      } else if (res.data?.code) {
                        close();
                        if (res?.data?.code === 'sms') {
                          otp.open({
                            onSuccess: (code, callback, close) => {
                              guest
                                .SignInWithoutCallback({
                                  data: {
                                    ...params,
                                    sms_code: code,
                                  },
                                })
                                .then((res) => {
                                  if (res.status) {
                                    close();
                                    keepAlive().then((res) => {
                                      if (res.data.mobile_verified === 'no') {
                                        phoneVerification.open({
                                          onSuccess: () => {
                                            alert.open({
                                              message: t(
                                                'თქვენი ნომერი ვერიფიცირებულია'
                                              ),
                                            });
                                          },
                                        });
                                      }
                                    });
                                  } else if (res.data?.code) {
                                    close();
                                    alert.open({ message: res.data?.desc });
                                  } else callback(res.data?.desc);
                                });
                              /* callback(error.desc)*/
                            },
                            onResend: (callback) => {
                              guest
                                .SignInWithoutCallback({
                                  data: {
                                    ...params,
                                  },
                                })
                                .then((res) => {
                                  callback(res.data?.left, res.data?.desc);
                                });
                            },
                          });
                        } else {
                          alert.open({
                            message: res.data?.desc,
                          });
                        }
                      } else callback(res.data?.desc);
                    });
                },
              });
              break;
            case 'sms':
              otp.open({
                onSuccess: (code, callback, close) => {
                  guest
                    .SignInWithoutCallback({
                      data: {
                        ...params,
                        sms_code: code,
                      },
                    })
                    .then((res) => {
                      if (res.status) {
                        close();
                        keepAlive().then((res) => {
                          if (res.data.mobile_verified === 'no') {
                            phoneVerification.open({
                              onSuccess: () => {
                                alert.open({
                                  message: t('თქვენი ნომერი ვერიფიცირებულია'),
                                });
                              },
                            });
                          }
                        });
                      } else if (res.data?.code) {
                        close();
                        alert.open({ message: res.data?.desc });
                      } else callback(res.data?.desc);
                    });
                  /* callback(error.desc)*/
                },
                onResend: (callback) => {
                  guest
                    .SignInWithoutCallback({
                      data: {
                        ...params,
                      },
                    })
                    .then((res) => {
                      callback(res.data?.left, res.data?.desc);
                    });
                },
              });
              break;
            default:
              alert.open({
                message: error?.desc,
              });
              break;
          }
        } else {
          alert.open({
            message: error?.desc,
          });
        }
      },
    });
  };

  return (
    <section className={classes.user}>
      <DimensionWrapper hidden={['gigantic']}>
        <Button
          onClick={() =>
            signInModal.open({
              onSuccess: (e) => {
                keepAlive();
                //  signInModal.close();
                //keepAlive();
              },
            })
          }
          variant='secondary'
          className={classNames(classes.btn, classes.auth)}
        >
          {t('შესვლა')}
        </Button>
      </DimensionWrapper>
      <Button
        variant='success'
        onClick={() =>
          registerModal.open({
            onSuccess: () => {
              Toast.show({
                content: t('თქვენ წარმატებით გაიარეთ რეგისტრაცია'),
              });
              signInModal.open({});
            },
          })
        }
        className={classNames(classes.btn, classes.register)}
        style={{ backgroundImage: `url(${RegisterBackground})` }}
      >
        {['chitovic', 'md'].indexOf(size) > -1 ? (
          <FontAwesomeIcon icon={faUserPlus} />
        ) : (
          <>
            <Icon
              Icon={GiftIcon}
              style={{ width: '5rem', height: '2.48rem' }}
              classname={classes.icon}
            />
            <span>{t('რეგისტრაცია')}</span>
          </>
        )}
        <div className={classes.tooltip}>
          <div className={classes.regCont}>
            <strong>{t('ახალი მომხმარებლებისთვის')}</strong>
            {/*<img src={RegisterBonus[i18n.language]} alt={'registration-bonus'} />*/}
            <img src={`https://www.lider-bet.com/promo/deposit-2025-pro/img/icons/popup-img.png`} alt={'registration-bonus'} />
            <p>{t('დარეგისტრირდი, გაიარე ვერიფიკაცია და მიიღე საჩუქრად 1000 ფრისპინამდე')}</p>
          </div>

        </div>
      </Button>
      <DimensionWrapper hidden={['sm', 'md', 'lg', 'xl', 'xxl']}>
        <Form
          style={{ display: 'flex' }}
          onSubmit={(e) => {
            e.preventDefault();
            signIn();
          }}
        >
          <div
            className={classes.inputContainer}
            style={{
              backgroundImage:
                'url("https://www.lider-bet.com/gui/web/css/2019/img/u_2019.png")',
            }}
          >
            <input
              type='username'
              placeholder={t('სახელი')}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <Button
              tabIndex={-1}
              type={'button'}
              variant='secondary'
              onClick={() =>
                recovery.open({
                  initialTab: 'username',
                  onSuccess: () => {},
                })
              }
            >
              {t('აღდგენა')}
            </Button>
          </div>
          <div
            className={classes.inputContainer}
            style={{
              backgroundImage:
                'url("https://www.lider-bet.com/gui/web/css/2019/img/p_2019.png")',
            }}
          >
            <input
              type='password'
              placeholder={t('პაროლი')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              tabIndex={-1}
              type={'button'}
              variant='secondary'
              onClick={() =>
                recovery.open({
                  initialTab: 'password',
                  onSuccess: () => {},
                })
              }
            >
              {t('აღდგენა')}
            </Button>
          </div>
          <Button
            /*onClick={() => signIn()}*/
            type={'submit'}
            variant='secondary'
            className={classes.btn}
          >
            {t('შესვლა')}
          </Button>
        </Form>
      </DimensionWrapper>
    </section>
  );
};
